/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Search_PlaceholderInputs */

const cs_deals_search_placeholder = /** @type {(inputs: Deals_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat název, klienta nebo další krok`)
};

const en_deals_search_placeholder = /** @type {(inputs: Deals_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search title, client, or next step`)
};

/**
* | output |
* | --- |
* | "Search title, client, or next step" |
*
* @param {Deals_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_search_placeholder = /** @type {((inputs?: Deals_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_search_placeholder(inputs)
	return cs_deals_search_placeholder(inputs)
});